import {
  MetricHeaderLeft,
  MetricHeaderMid,
  MetricHeaderRight,
  MetricHeaderWrapper,
} from "../../components/Headers/Atom"
import { HeaderInfoNav } from "../../components/Headers/Reusable"
import { useNavigate } from "react-router-dom"
import { ProvidersHeaderGeneralDropdownFilter } from "../../components/Dropdown/ProvidersHeaderDropdownFilter"
import { useAppDispatch, useAppSelector } from "../../redux/hooks"
import DownloadIcon from "@mui/icons-material/Download"
import { DashboardPaper } from "../Dashboard/Old/Atom"
import {
  Box,
  Button,
  IconButton,
  Paper,
  Typography,
  styled,
} from "@mui/material"
import { useMemo } from "react"
import { useSelector } from "react-redux"
import {
  setMaevaSelectedGroupsNoAll,
  setMaevaSelectedPracticesNoAll,
  setMaevaSelectedRegionsNoAll,
} from "../../redux/slices/metricSlice"
import ExportPdfCsv from "../../components/Button/ExportPdfCsv"
import { TabList } from "@mui/lab"

type headerProps = {
  name: string
  handleDownload?: any
  rows?: any
}

type navigationProps = {
  data: {
    label: string
    value: any
  }[]
}

export const HuddleHeader = (props: headerProps) => {
  const { name, handleDownload, rows } = props
  const navigate = useNavigate()
  const dispatch = useAppDispatch()

  const loading = useAppSelector((state) => state.app.loading)
  const state = useAppSelector((state) => state.huddle)

  // const { huddleGroups, huddleRegions, huddleOffices } = state
  // const { selectedHuddleGroup, selectedHuddleOffice } = state
  // const { selectedHuddleRegion } = state

  const huddleGroups = useSelector((state: any) => {
    return state.metric.maevaGroups
  })

  const huddleRegions = useSelector((state: any) => {
    return state.metric.maevaRegions
  })

  const huddleOffices = useSelector((state: any) => {
    return state.metric.maevaPractices
  })

  const maevaSelectedGroupsNoAll = useSelector((state: any) => {
    return state.metric.maevaSelectedGroupsNoAll
  })

  const selectedHuddleGroup = maevaSelectedGroupsNoAll?.[0]

  const maevaSelectedRegionsNoAll = useSelector((state: any) => {
    return state.metric.maevaSelectedRegionsNoAll
  })

  const selectedHuddleRegion = maevaSelectedRegionsNoAll?.[0]

  const maevaSelectedPracticesNoAll = useSelector((state: any) => {
    return state.metric.maevaSelectedPracticesNoAll
  })

  const selectedHuddleOffice = maevaSelectedPracticesNoAll?.[0]
  const lastUpdatedDate = useSelector((state: any) => {
    return state.huddle.lastUpdatedDate
  })
  const handleGroupFilter = (event: any) => {
    const {
      target: { value },
    } = event

    dispatch(setMaevaSelectedGroupsNoAll([value]))
    dispatch(setMaevaSelectedRegionsNoAll(null))
    dispatch(setMaevaSelectedPracticesNoAll(null))
  }
  const handleRegionFilter = (event: any) => {
    const {
      target: { value },
    } = event

    dispatch(setMaevaSelectedRegionsNoAll([value]))
    dispatch(setMaevaSelectedPracticesNoAll(null))
  }
  const handleOfficeFilter = (event: any) => {
    const {
      target: { value },
    } = event

    dispatch(setMaevaSelectedPracticesNoAll([value]))
  }
  const handleClickBack = () => {
    navigate(-1)
  }

  return (
    <MetricHeaderWrapper sx={{ justifyContent: "flex-start" }}>
      <MetricHeaderLeft>
        <HeaderInfoNav
          name={name}
          handleClickBack={handleClickBack}
          isBack={false}
        />
      </MetricHeaderLeft>

      <MetricHeaderMid sx={{ mx: "auto" }}>
        <ProvidersHeaderGeneralDropdownFilter
          id={1}
          key={"huddle-filter-1"}
          disabled={loading}
          handleFilter={handleGroupFilter}
          filterData={huddleGroups}
          headerLabel="Group Name"
          value={selectedHuddleGroup}
          placeholder="Select a Group"
        />
        <ProvidersHeaderGeneralDropdownFilter
          id={2}
          key={"huddle-filter-2"}
          disabled={!selectedHuddleGroup || loading}
          handleFilter={handleRegionFilter}
          filterData={huddleRegions}
          headerLabel="Regions"
          value={selectedHuddleRegion}
          placeholder="Select a Region"
        />
        <ProvidersHeaderGeneralDropdownFilter
          id={3}
          key={"huddle-filter-3"}
          disabled={!selectedHuddleRegion || loading}
          handleFilter={handleOfficeFilter}
          filterData={huddleOffices}
          headerLabel="Office"
          value={selectedHuddleOffice}
          placeholder="Select an Office"
        />
        {selectedHuddleOffice && (
          <Box
            sx={{
              height: "100%",
              display: "flex",
              alignItems: "flex-end",
              fontSize: "14px",
              color: "grey",
              margin: "1rem 1rem 0 1rem",
            }}
          >
            Last updated on: {lastUpdatedDate || "-"}
          </Box>
        )}
      </MetricHeaderMid>
      <MetricHeaderRight
        sx={{
          paddingTop: "1rem",
        }}
      >
        {/* <Button
          sx={{
            backgroundColor: "#1A428A",
            "&:hover": { backgroundColor: "#1A428A" },
            display: "flex",
            color: "#FFFFFF",
          }}
          onClick={handleDownload}
        >
          <IconButton
            disableRipple
            sx={{ color: "#FFFFFF", padding: "0", fontSize: 14 }}
          >
            <DownloadIcon />
          </IconButton>
          <Typography marginLeft={1} fontSize={14}>
            Download
          </Typography>
        </Button> */}
        {selectedHuddleOffice && (
          <ExportPdfCsv handleDownload={handleDownload} />
        )}
      </MetricHeaderRight>
    </MetricHeaderWrapper>
  )
}

export const NavigationAssistant = ({ data }: navigationProps) => {
  const message = useMemo(() => {
    let message = "Select filters"
    for (let item of data) {
      if (!item.value) {
        return item.label
      }
    }
    return message
  }, [data])

  return (
    <DashboardPaper
      sx={{
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      {message}
    </DashboardPaper>
  )
}

export const StyledTabsList = styled(TabList)({
  // height: "5vh",
  color: "#706F70",
  marginLeft: "29px",
  ".MuiTab-root": {
    color: "#706F70",
    textTransform: "capitalize",
    fontSize: "16px",
    fontFamily: "Poppins",
    alignItems: "flex-start",
    // padding: 0,
    paddingLeft: 0,
  },
  ".MuiTab-root.Mui-selected": {
    color: "#000000",
    fontWeight: "600",
  },
  ".MuiTabs-indicator": {
    backgroundColor: "#3C77EF",
    maxWidth: "34px",
    height: "4px",
  },
})

export const TableWrapperPaper = styled(Paper)({
  // margin: "0px 24px",
  display: "flex",
  flexDirection: "column",
  borderRadius: "4px",
  boxShadow: "0px 2px 8px #00000022",
  height: "fit-content",
  width: "fit-content",
  // flex: 1,
  // flexGrow: 1,
})

export const TableWrapperPaperOld = styled(Paper)({
  // margin: "0px 24px",
  display: "flex",
  flexDirection: "column",
  borderRadius: "4px",
  boxShadow: "0px 2px 8px #00000022",
  // height: "fit-content",
  // width: "fit-content",
  flex: 1,
  flexGrow: 1,
})

//Unused Code

// Typography Table Header

{
  /* <Typography
                  sx={{
                    pl: "25px",
                    py: "8px",
                    fontWeight: "bold",
                    backgroundColor: "#3C77EF",
                    color: "#fff",
                    borderTopLeftRadius: "4px",
                    borderTopRightRadius: "4px",
                  }}
                >
                  Daily Production Goal
                </Typography> */
}

// Huddle Table Old

{
  /* <HuddleTable
                  columns={columnSet1}
                  data={huddleData?.yesterday?.providers || []}
                  enableEditing={enableEditing}
                  blurHandler={openDialog}
                /> */
}
